/** Shared with coach camera calibration so a settings change does not cut a live clip. */
let tablePhoneRecording = false;

export function isOffTableVideoRecording() {
  return tablePhoneRecording;
}

export function publishTablePhoneRecording(active) {
  tablePhoneRecording = Boolean(active);
}
